/** Consecutive extracts raise banked salvage. Death resets the streak. */

export const EXTRACT_HEAT_BONUS_PER = 0.06;
export const EXTRACT_HEAT_CAP = 5;

export function extractHeatMultiplier(streak: number): number {
  const heat = Math.min(Math.max(0, streak), EXTRACT_HEAT_CAP);
  return 1 + heat * EXTRACT_HEAT_BONUS_PER;
}

export function extractHeatBonusPct(streak: number): number {
  return Math.round((extractHeatMultiplier(streak) - 1) * 100);
}

export function applyExtractSuccess(
  streak: number,
  salvage: number,
): { streak: number; salvage: number; bonus: number } {
  const multiplied = Math.round(salvage * extractHeatMultiplier(streak));
  return { streak: streak + 1, salvage: multiplied, bonus: multiplied - salvage };
}

export function applyExtractFailure(): { streak: 0 } {
  return { streak: 0 };
}
